import { z } from 'zod';

/**
 * Phase ⑦ FinalPlanWriter — output `plan_detaille`.
 *
 * Format : markdown Section II final, structuré en H2 par argument
 * (`## A.` / `## B.` / ...) avec sous-sections `### En droit`, `### Application
 * aux faits`, `### Anticipation des contre-arguments`. Single-pass Claude Sonnet.
 *
 * Pas de validation regex stricte côté Zod — on incite la structure dans le
 * prompt et on itère sur les déviations via les logs (mêmes raisons que
 * `CaseBriefOutputSchema`).
 *
 * Voir hub doc § 4 ⑦ (`docs/architecture/plan-detaille-v2.md`).
 */
export const FinalPlanSchema = z.string();
export type FinalPlan = z.infer<typeof FinalPlanSchema>;
